import { render } from "./IconMedium.vue?vue&type=template&id=6badada2&scoped=true"
import script from "./IconMedium.vue?vue&type=script&lang=js"
export * from "./IconMedium.vue?vue&type=script&lang=js"

import "./IconMedium.vue?vue&type=style&index=0&id=6badada2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6badada2"]])

export default __exports__